"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (array, callback) {
  return array.reduce(function (partialObject, element) {
    return callback(partialObject, element);
  }, {});
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/arrayToObject.js
// module id = 4434
// module chunks = 168707334958949